import { DashboardCard } from '@/components/ui/dashboard-card.tsx';
import { LastUpdateTimestamp } from '@/components/last-update-timestamp.tsx';
import { cn } from '@/utils/utils.ts';
import { useGetPlantControlPanelOverviewQuery } from '@/features/plants/hooks/queries/[plantId]/use-get-plant-control-panel-overview.ts';
import { useParams } from 'react-router';
import { PlantPowerFlow3Sources } from '@/assets/plant/power-flow-3-sources.tsx';
import { useTranslation } from 'react-i18next';

const PlantControlPowerFlow = ({
  isLoading,
  className,
}: {
  isLoading?: boolean;
  className?: string;
}) => {
  const { t } = useTranslation();

  const { plantId } = useParams();
  const {
    data,
    isLoading: isPlantControlPanelLoading,
    dataUpdatedAt: dataUpdatedAt,
  } = useGetPlantControlPanelOverviewQuery({
    plantId: plantId || '',
  });

  const currentPower = data?.currentPower;
  const measurements = {
    grid: currentPower?.gridPower,
    consumption: currentPower?.consumptionPower,
    batteryPower: currentPower?.batteryPower,
    batterySoC: currentPower?.batterySoC,
  };

  const isDataAvailable =
    currentPower?.gridPower !== 0 ||
    currentPower?.consumptionPower !== 0 ||
    currentPower?.batteryPower !== 0 ||
    currentPower?.batterySoC !== 0;

  return (
    <DashboardCard
      className={cn('', className)}
      isLoading={isPlantControlPanelLoading || isLoading}
    >
      <LastUpdateTimestamp updatedAt={dataUpdatedAt} />

      {isDataAvailable ? (
        <div className="flex h-full w-full items-center justify-center">
          <PlantPowerFlow3Sources
            width="100%"
            height="100%"
            className="max-w-[26rem]"
            measurements={measurements}
          />
        </div>
      ) : (
        <div className="flex h-full min-h-[238px] w-full items-center justify-center rounded-md bg-gray-50">
          <span className="text-muted-foreground">
            {t('devices.batteryModule.noDataFound')}
          </span>
        </div>
      )}
    </DashboardCard>
  );
};

export default PlantControlPowerFlow;
